import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IMaterial } from "../../../../../../core/models/disciplines";
import { useMaterial } from "../../../../hooks/useMaterials";
import { useMaterialStore } from "../../../../stores/materialStore";
import { useNewSubjectStore } from "../../../../stores/newSubjectStore";
import { useFilterConfigStore } from "../../../../stores/filterConfig";
import MaterialCard from "../../materialCard";
import BrainLoadingWrapper from "../../../../../../core/components/molecules/BrainLoading";
import { useDisciplinesAuxStore } from "../../../../stores/auxStore";
import { IResponseFavorite } from "../../../../hooks/useContentFavorite";
import getSubjectByFilter from '../../../../../../core/commom/getSubjectByFilter';
import { useFinishMaterial } from "../../../../../../core/hooks/useFinishMaterial";

interface IContentModalMaterial {
  onClose: () => void;
}

const ContentModalMaterial: React.FC<IContentModalMaterial> = ({ onClose }) => {
  const { module, discipline, slug } = useParams();
  const { mutate, isPending } = useMaterial();
  const { selectedSubjects } = useNewSubjectStore();
  const { materials, setAllMaterials } = useMaterialStore();
  const { status, favorites } = useFilterConfigStore();
  const { setPlaylistResultNumber } = useDisciplinesAuxStore();

  const { mutate: finishMaterial, isPending: isLoading, isSuccess } = useFinishMaterial();

  const [dataArray, setDataArray] = useState<IMaterial[]>([])

  useEffect(() => {
    if(materials?.length > 0) {
      filterMaterial()
    } 
  }, [materials, selectedSubjects])

  useEffect(() => {
    if(materials?.length > 0) {
      filterMaterial();
    }
  }, [status, favorites])

  useEffect(() => {
    if(module) {
      mutate(module)
    }
  }, []);

  const callbackFav = (data: IResponseFavorite) => {
    if(data.ok && module) {
      mutate(module)
    }
  }

  useEffect(() => {
    if(isSuccess && module) {
      mutate(module);
    }
  }, [isLoading])

  const filterMaterial = () => {
    if(materials?.length > 0) {
      const aux = [...materials];
      let filteredData = aux;
      
      if(selectedSubjects?.length > 0) {
        filteredData = filteredData.filter((it) => selectedSubjects.includes(it.subjects[0].slug))
      }

      if(status?.length === 1) {
        if(status.includes('not_seen')) {
          filteredData = filteredData.filter((it) => !it.done)
        } else if(status.includes('seen')) {
          filteredData = filteredData.filter((it) => it.done)
        }
      }

      if(favorites) {
        filteredData = filteredData.filter((it) => it.favorite)
      }

      setAllMaterials(filteredData);
      setPlaylistResultNumber(filteredData.length);
      setDataArray(filteredData);
    }
  }

  function dispatchSetContentAsDoneEvent(id: string) {
    const setContentAsDone = new CustomEvent('setContentAsDone', {
      detail: {
        contentId: id,
      },
    });
    window.dispatchEvent(setContentAsDone);
  }

  const onFinish = (id: string, slug: string) => {
    if (slug) {
      finishMaterial(slug);
      dispatchSetContentAsDoneEvent(id);
    }
  };

  if(isPending) {
    return <BrainLoadingWrapper />
  }

  return (
    <Fragment>
      {dataArray.map((it, i) => (
        <MaterialCard
          key={i}
          material={it}
          discipline={discipline ?? ''}
          module={module ?? ''}
          subjectSlug={it.subjects[0].slug}
          subject={getSubjectByFilter(it.subjects, selectedSubjects)}
          slug={slug ?? ''}
          done={it.done}
          favorite={it.favorite}
          onClose={onClose}
          callback={(data) => callbackFav(data)}
          onDone={(id: string, slug: string) => onFinish(id, slug)}
        />
      ))}
    </Fragment>
  )
}

export default ContentModalMaterial;